module.exports = __webpack_public_path__ + "img/s-1.fc0be621.png";